import React, { Component } from 'react'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import LoanFeasibilityUI from './LoanFeasibilityUI.js'

class LoanFeasibilitySF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showEmail: false,
      sendingEmail: false,
      emailSuccessMsg: null,
      emailErrorList: [],
      sendingInternalEmail: false,
      internalEmailSuccessMsg: null,
      internalEmailErrorList: [],
      // upload
      fileUploadMode: false,
      fileUploadSuccessMsg: null,
      fileUploadErrorList: null,
      fileUploadSubmitted: false,
      //
      fileDownloadSubmitted: false
    }
  }

  render() {
    return (
      <LoanFeasibilityUI
        context={this.props.context}
        loan={this.props.loan}
        loanFeasibility={this.props.loanFeasibility}
        feasibilityItemList={this.props.feasibilityItemList}
        onRefreshClick={this.props.onRefreshClick}
        //
        onIntRemClk={this.props.onInternalRemarksClick}
        internalRemarksMode={this.props.internalRemarksMode}
        //
        onExtRemClk={this.props.onExternalRemarksClick}
        externalRemarksMode={this.props.externalRemarksMode}
        onCancelRemarksClick={this.props.onCancelRemarksClick}
        objectId={this.props.objectId}
        selectedRemarks={this.props.selectedRemarks}
        onShowDetails={this.props.onShowDetails}
        showDetailsMode={this.props.showDetailsMode}
        toggleEditable={this.props.toggleEditable}
        editable={this.props.editable}
        //
        showEmail={this.state.showEmail}
        onShowEmail={() => this.setState({ showEmail: true })}
        onHideEmail={() => this.setState({ showEmail: false })}
        onSendEmail={this.onSendEmail}
        sendingEmail={this.state.sendingEmail}
        emailSuccessMsg={this.state.emailSuccessMsg}
        emailErrorList={this.state.emailErrorList}
        onSendInternalEmail={this.onSendInternalEmail}
        sendingInternalEmail={this.state.sendingInternalEmail}
        internalEmailSuccessMsg={this.state.internalEmailSuccessMsg}
        internalEmailErrorList={this.state.internalEmailErrorList}
        // upload
        fileUploadMode={this.state.fileUploadMode}
        fileUploadSubmitted={this.state.fileUploadSubmitted}
        fileUploadSuccessMsg={this.state.fileUploadSuccessMsg}
        fileUploadErrorList={this.state.fileUploadErrorList}
        onFileUploadClick={this.onFileUploadClick}
        onfileUploadCancel={() => { this.setState({ fileUploadMode: false }) }}
        // signedUrlApi={`/api/su/accounts/${this.props.account.accountId}/objectCode/loan_feasibility/objectId/${this.state.fileObjectId}/remarks/files/fileUploadSignedUrl`}
        onfileUpload={this.onfileUpload}
        //
        fileDownloadSubmitted={this.state.fileDownloadSubmitted}
        onFileDownloadClick={this.onFileDownloadClick}
      />
    )
  }

  onSendEmail = () => {
    let sendingEmail = this.state.sendingEmail
    if (sendingEmail)
      return

    this.setState({
      emailSuccessMsg: null,
      emailErrorList: [],
      sendingEmail: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/feasibility/emailToClient`,
      this.onSendEmailCallback, {}
    )
  }

  onSendEmailCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      emailSuccessMsg: response.success,
      emailErrorList: errorList,
      sendingEmail: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          emailSuccessMsg: null,
          showEmail: false
        })
      }, 3000)
    }
  }

  onSendInternalEmail = () => {
    let sendingInternalEmail = this.state.sendingInternalEmail
    if (sendingInternalEmail)
      return

    this.setState({
      internalEmailSuccessMsg: null,
      internalEmailErrorList: [],
      sendingInternalEmail: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/feasibility/emailToUnderwriter`,
      this.onSendInternalEmailCallback, {}
    )
  }

  onSendInternalEmailCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      internalEmailSuccessMsg: response.success,
      internalEmailErrorList: errorList,
      sendingInternalEmail: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          internalEmailSuccessMsg: null
        })
      }, 3000)
    }
  }

  onFileUploadClick = (event) => {
    let objectId = event.currentTarget.getAttribute('data-object-id')
    this.setState({ fileUploadMode: true, fileObjectId: objectId })
  }

  onfileUpload = (fileId, fileName, fileType, fileSize) => {
    this.setState({
      fileUploadSubmitted: true,
      fileUploadSuccessMsg: null,
      fileUploadErrorList: []
    })
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/objectCode/loan_feasibility/objectId/${this.state.fileObjectId}/remarks/files`,
      this.onfileUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onfileUploadCallback = (response) => {
    this.setState({ fileUploadSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      fileUploadSuccessMsg: response.success,
      fileUploadErrorList: errorList,
    })

    // this.props.onRefreshClick('noBusy')

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          fileUploadSuccessMsg: null
        })
      }, 2000)
    }
  }

  onFileDownloadClick = (event) => {
    let objectId = event.currentTarget.getAttribute('data-object-id')
    let remarksDate = event.currentTarget.getAttribute('data-date')
    this.setState({ fileDownloadSubmitted: true })
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/objectCode/loan_feasibility/objectId/${objectId}/remarksDate/${remarksDate}/remarks/files/fileDownloadSignedUrl`,
      this.onFileDownloadClickCallback, null, null
    )
  }

  onFileDownloadClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      fileDownloadSubmitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

}

export default LoanFeasibilitySF
